import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BodyM } from '@sorare/core/src/atoms/typography';
import { ANY_SPORT_MARKET_SHOP_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

const Root = styled(Vertical).attrs({
  gap: 2,
  center: true,
})`
  padding: var(--triple-unit);
  border-radius: var(--double-unit);
  border: 1px solid var(--c-nd-150);
`;

export const EmptyCart = () => {
  const {
    canOpenCartOpenPaymentBoxAndCloseCurrentWebview: canCloseCurrentWebview,
    postMessage,
  } = useIsMobileApp();
  const { generateSportContextPath } = useSportContext();

  return (
    <Root className="text-center">
      <FontAwesomeIcon
        icon={faShoppingCart}
        size="2x"
        color="var(--c-nd-200)"
      />
      <Vertical gap={0}>
        <BodyL bold>
          <FormattedMessage
            defaultMessage="Your cart is empty"
            id="emptyCart.title"
          />
        </BodyL>
        <BodyM color="var(--c-nd-600)">
          <FormattedMessage
            defaultMessage="The cards you add will appear here"
            id="emptyCart.desc"
          />
        </BodyM>
      </Vertical>
      {canCloseCurrentWebview ? (
        <Button
          size="medium"
          color="secondary"
          onClick={() => {
            postMessage('closeCurrentWebview');
          }}
        >
          <FormattedMessage
            id="emptyCart.ios"
            defaultMessage="Go back to marketplace"
          />
        </Button>
      ) : (
        <Button
          size="medium"
          to={generateSportContextPath(ANY_SPORT_MARKET_SHOP_INSTANT_BUY)}
          color="secondary"
        >
          <FormattedMessage
            defaultMessage="Browse marketplace"
            id="emptyCart.goToMarketplace"
          />
        </Button>
      )}
    </Root>
  );
};
